"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});

exports.default = function () {

	var innerTextService = function innerTextService(ids) {};

	var spanTextService = function spanTextService(ids, entityType) {};

	var invoiceDtoCheck = function invoiceDtoCheck(data) {
		var ids = [];
		if (data && data.length > 0 && data[0].hasOwnProperty("invoices")) {
			for (var i = 0; i < data.length; i++) {
				for (var j = 0; j < data[i].invoices.length; j++) {
					if (data[i].invoices[j].hasFileName) {
						ids.push(data[i].invoices[j].id);
					}
				}
			}
			if (ids.length > 0) {
				innerTextService(ids);
			}
		}
	};

	var fileWithFileNameCheck = function fileWithFileNameCheck(data, entityType) {

		var ids = [];
		if (data[0]) {
			for (var i = 0; i < data.length; i++) {
				if (data[i].hasFileName) {
					ids.push(data[i].id);
				}
			}
			if (ids.length > 0) {
				spanTextService(ids, entityType);
			}
		}
	};

	$(function () {
		$(document).on('draw.dt', '[data-table=orders]', function () {
			var data = $("[data-table=orders]").DataTable().data();

			invoiceDtoCheck(data);
		});

		$(document).on('draw.dt', '[data-table=invoices]', function () {
			var data = $("[data-table=invoices]").DataTable().data();

			fileWithFileNameCheck(data, "invoices");
		});

		$(document).on('draw.dt', '[data-table=creditInvoices]', function () {
			var data = $("[data-table=creditInvoices]").DataTable().data();

			fileWithFileNameCheck(data, "creditInvoices");
			invoiceDtoCheck(data);
		});
	});
};

var $ = require("jquery");
//var service = abp.services.api.file;

module.exports = exports["default"];


//////////////////
// WEBPACK FOOTER
// ./Scripts/app/initializers/downloadIcons.js
// module id = 1172
// module chunks = 0